/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  PostApiV1Classroomdiscipline200,
  PostApiV1Classroomdiscipline400,
  PostApiV1Classroomdiscipline401,
  PostApiV1Classroomdiscipline500,
  PostApiV1ClassroomdisciplineMutationRequest,
  PostApiV1ClassroomdisciplineMutationResponse,
} from "../../types/classPlanningController/PostApiV1Classroomdiscipline.ts";
import { classroomDisciplineDetailViewModelSchema } from "../classroomDisciplineDetailViewModelSchema.ts";
import { createClassroomDisciplineViewModelSchema } from "../createClassroomDisciplineViewModelSchema.ts";

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const postApiV1Classroomdiscipline200Schema = z.lazy(
  () => classroomDisciplineDetailViewModelSchema,
) as unknown as ToZod<PostApiV1Classroomdiscipline200>;

/**
 * @description (Bad Request) Requisição em formato incorreto ou com dados faltantes.
 */
export const postApiV1Classroomdiscipline400Schema =
  z.any() as unknown as ToZod<PostApiV1Classroomdiscipline400>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const postApiV1Classroomdiscipline401Schema =
  z.any() as unknown as ToZod<PostApiV1Classroomdiscipline401>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const postApiV1Classroomdiscipline500Schema =
  z.any() as unknown as ToZod<PostApiV1Classroomdiscipline500>;

export const postApiV1ClassroomdisciplineMutationRequestSchema = z.lazy(
  () => createClassroomDisciplineViewModelSchema,
) as unknown as ToZod<PostApiV1ClassroomdisciplineMutationRequest>;

export const postApiV1ClassroomdisciplineMutationResponseSchema = z.lazy(
  () => postApiV1Classroomdiscipline200Schema,
) as unknown as ToZod<PostApiV1ClassroomdisciplineMutationResponse>;
